import types from './types';

const showError = httpError => ({
  type: types.SHOW_ERROR,
  payload: httpError,
});

const closeError = () => ({
  type: types.CLOSE_ERROR,
});

export default {
  showError,
  closeError,
};
